"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.typesContext = exports.TypesProvider = void 0;
var _react = require("react");
const typesContext = exports.typesContext = /*#__PURE__*/(0, _react.createContext)({});
const TypesProvider = exports.TypesProvider = typesContext.Provider;
